import React from "react";

import { Component } from "../../../../commons/types/component";
import cn from "../../libs/class-name";

interface Props extends Component {
  children: React.ReactNode;
}

const DeviceInformation = ({ classNames = [], children }: Props) => (
  <div className={cn("DeviceInformation", [], classNames)}>{children}</div>
);

export default DeviceInformation;
